import {
    defaultProductResultDto,
    ProductResultDto,
} from "src/dtos/productResult/ProductResultDto";
import {
    defaultPrdInspectResultDto,
    PrdInspectResultDto,
} from "src/dtos/prdInspectResult/prdInspectResultDto";

export interface PRD3060_R01Dto extends ProductResultDto {
    brandCd: string;
    brandNm: string;
    lotNo: string;
    itemCost: number;
}

export interface PRD3060_R01DetailDto extends PrdInspectResultDto {
    badCaseNm: string;
    badCaseQty: number;
}

export const defaultPRD3060_R01Data: PRD3060_R01Dto = {
    ...defaultProductResultDto,
    itemCost: 0,
    brandCd: "",
    brandNm: "",
    lotNo: "",
};

export const defaultPRD3060_R01DetailData: PRD3060_R01DetailDto = {
    ...defaultPrdInspectResultDto,
    badCaseNm: "",
    badCaseQty: 0,
};
